import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import {
  CountTitle,
  DashboardCard,
  DashboardCardContainer,
  DashboardContainer,
  DashboardContainerLeft,
  DashboardContainerRight,
  DashboardContainerRightTitle,
  DashboardCountCard,
  DashboardCountCardLeft,
  DashboardCountCardRight,
  DashboardCountContainer,
  DashboardCountContainerLeft,
  DashboardCountContainerRight,
  DashboardCountView,
  OwnerDashboardHeaderContainer,
  DashboardHeaderTitle,
  DashboardTableContainer,
  DashboardTableContent,
  DashboardTableView,
  EditButton,
  FileInput,
  Image,
  LabelCount,
  LoaderWrapper,
  LogoTitle,
  ButtonWrapper,
  ImageWrapper,
} from './dashboard.style';
import { IconButton, Label, Loader } from '../../../Components/uielements';
import DashboardTable from './table/dashboardTable';
import { useUserContext } from '../../../hooks/UserContext';
import * as UserService from '../../../services/bioplus-services/user';
import * as GeofenceService from '../../../services/bioplus-services/geofence';
import * as LogBookService from '../../../services/bioplus-services/logBook';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';

// import CVDServices from '../../../services/bioplus-services/cvd';
import LogbookService from '../../../services/bioplus-services/logBook';
import DateUtils from '../../../utils/date-utils';
import CameraOne from '../../../assets/PNG/camera-1.png';
import CameraTwo from '../../../assets/PNG/camera-2.png';

import { IntlMessages } from '../../../helper/langHelper';
import { CenterContainer, TooltipBox } from '../../../Components/uielements/tooltip/tooltip.style';
import { useNavigate } from 'react-router-dom';
import { EditWhiteIcon } from '../../../Components/icons';
import service from '../../../services/bioplus-services/service';
import { cvdCountByCompany } from '../../../services/bioplus-services/cvd';

const Dashboard = () => {
  const userRole = useUserContext().company;
  const companyId = userRole?.companyId?.id;
  const userDetails = useUserContext()?.user;
  const userId = userDetails?._id; // Get user ID for embedded report

  const userCountQuery = useQuery(['userCount', userRole], () =>
    UserService.countByCompany(userRole?.companyId?.id)
  );
  const geofenceCountQuery = useQuery(['geofenceCount', userRole], () =>
    GeofenceService.countByCompany(userRole?.companyId?.id)
  );
  const logBookCountQuery = useQuery(['logBookCount', userRole], () =>
    LogBookService.countByCompany(userRole?.companyId?.id)
  );

  const CVDCounts = useQuery(['cvdCount'], () => cvdCountByCompany(userRole?.companyId?.id));

  const query = useQuery(['logBookEntries'], () =>
    LogbookService.listByCompany(
      companyId,
      {
        name: '',
        fromDate: DateUtils.last7Days(),
        toDate: DateUtils.today(),
      },
      0,
      4
    )
  );

  // images upload
  const [image, setImage] = useState(userDetails?.camera1);
  const [imageTwo, setImageTwo] = useState(userDetails?.camera2);
  const [isUploadingOne, setIsUploadingOne] = useState(false);
  const [isUploadingTwo, setIsUploadingTwo] = useState(false);
  const [isFetching, setIsFetching] = useState(false);

  // Embedded report state
  // const [embeddedReportUrl, setEmbeddedReportUrl] = useState(null);
  // const [isLoadingReport, setIsLoadingReport] = useState(false);
  // const [reportError, setReportError] = useState(null);

  const handleImageChangeOne = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = async () => {
        const base64String = reader.result.split(',')[1];

        const payload = {
          _id: userDetails?._id,
          camera1: base64String,
        };
        setIsUploadingOne(true);
        await UserService.uploadCameraImage(payload);
        setImage(base64String);
        setIsUploadingOne(false);
      };
      reader.readAsDataURL(file);
    }
  };
  const handleImageChangeTwo = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = async () => {
        const base64String = reader.result.split(',')[1];

        const payload = {
          _id: userDetails?._id,
          camera2: base64String,
        };
        setIsUploadingTwo(true);
        await UserService.uploadCameraImage(payload);
        setImageTwo(base64String);
        setIsUploadingTwo(false);
      };
      reader.readAsDataURL(file);
    }
  };

  const navigate = useNavigate();
  const handleNaviagte = (path) => {
    if (path) {
      navigate(path);
    }
  };

  const tableData = query?.data ?? [];
  // hover tooltip
  const [showTooltipUser, setIsHoveredUser] = useState(false);
  const [showTooltipPremise, setIsHoveredPremise] = useState(false);
  const [showTooltipGeofence, setIsHoveredGeofence] = useState(false);
  const [showTooltipLogBook, setIsHoveredLogBook] = useState(false);
  // const [showTooltipNotification, setIsHoveredNotification] = useState(false);
  const [showTooltipSOS, setIsHoveredSOS] = useState(false);

  const handleMouseEnter = (onSet) => {
    onSet(true);
  };
  const handleMouseLeave = (onSet) => {
    onSet(false);
  };

  const fetchImages = async () => {
    try {
      setIsFetching(true);
      const data = await service.get('users/self', localStorage.getItem('session'));

      if (data) {
        setImage(data?.data?.camera1);
        setImageTwo(data?.data?.camera2);
        setIsFetching(false);
      }
    } catch (error) {
      setIsFetching(false);
    }
  };

  // Fetch embedded report URL
  // const fetchEmbeddedReportUrl = useCallback(async () => {
  //   if (!userId) return;

  //   try {
  //     setIsLoadingReport(true);
  //     setReportError(null);

  //     const payload = {
  //       userId: userId,
  //     };

  //     const response = await getEmbeddedReportUrl(payload);

  //     if (response) {
  //       setEmbeddedReportUrl(response);
  //     } else {
  //       setReportError('No embedded URL received');
  //     }
  //   } catch (error) {
  //     console.error('Error fetching embedded report URL:', error);
  //     setReportError('Failed to load embedded report');
  //   } finally {
  //     setIsLoadingReport(false);
  //   }
  // }, [userId]);

  useEffect(() => {
    fetchImages();
    // fetchEmbeddedReportUrl();
  }, [userId]);

  // const handleNavigateToAddOnPage = () => {
  //   navigate('/addOn');
  // };

  const handleManageSubscription = async () => {
    navigate('/update-profile');
  };

  return (
    <DashboardContainer>
      {/* hearder section */}
      <OwnerDashboardHeaderContainer>
        <DashboardHeaderTitle>
          <IntlMessages id="header.dashboard" />
        </DashboardHeaderTitle>
        <ButtonWrapper>
          {/* <IconButton
            text={<IntlMessages id="button.text.add.on" />}
            icon={<AddPlusIcon />}
            onClick={handleNavigateToAddOnPage}
          /> */}
          <IconButton
            text={<IntlMessages id="text.update.profile" />}
            icon={<ManageAccountsIcon />}
            onClick={handleManageSubscription}
          />
        </ButtonWrapper>
      </OwnerDashboardHeaderContainer>

      {/* Embedded Report Section */}
      {/* 
      <DashboardCardContainer>
        {isLoadingReport && (
          <div style={{ padding: '20px', textAlign: 'center' }}>
            <Loader loadingText="Loading Report..." />
          </div>
        )}

        {reportError && (
          <div style={{ padding: '20px', textAlign: 'center', color: 'red' }}>
            <Label color="red">{reportError}</Label>
          </div>
        )}

        {embeddedReportUrl && (
          <div style={{ padding: '20px', height: '600px' }}>
            <Label weight="bold" size="header1" color="lightGreen" transform="uppercase">
              Analytics Report
            </Label>
            <iframe
              src={embeddedReportUrl}
              width="100%"
              height="100%"
              frameBorder="0"
              allowFullScreen
              title="Embedded Analytics Report"
              style={{ marginTop: '10px', borderRadius: '8px' }}
            />
          </div>
        )}
      </DashboardCardContainer> */}

      {/* card section */}
      <DashboardCardContainer>
        <DashboardContainerLeft>
          <DashboardCard>
            {isUploadingOne || isFetching ? (
              <LoaderWrapper>
                <Loader loadingText="Uploading..." />
              </LoaderWrapper>
            ) : (
              <>
                <EditButton onClick={() => document.getElementById('imageUpload').click()}>
                  <EditWhiteIcon />
                </EditButton>
                <FileInput
                  id="imageUpload"
                  type="file"
                  accept="image/*"
                  onChange={handleImageChangeOne}
                  multiple={false}
                />
                {image ? (
                  <ImageWrapper>
                    <Image src={`data:image/png;base64,${image}`} alt="Camera" />
                  </ImageWrapper>
                ) : (
                  <ImageWrapper>
                    <Image src={CameraOne} alt="camera image" />
                  </ImageWrapper>
                )}
              </>
            )}
            <LogoTitle>CAMERA #1</LogoTitle>
          </DashboardCard>
          <DashboardCard>
            {isUploadingTwo || isFetching ? (
              <LoaderWrapper>
                <Loader loadingText="Uploading..." />
              </LoaderWrapper>
            ) : (
              <>
                <EditButton onClick={() => document.getElementById('imageUploadTwo').click()}>
                  <EditWhiteIcon />
                </EditButton>
                <FileInput
                  id="imageUploadTwo"
                  type="file"
                  accept="image/*"
                  onChange={handleImageChangeTwo}
                  multiple={false}
                />
                {imageTwo ? (
                  <ImageWrapper>
                    <Image src={`data:image/png;base64,${imageTwo}`} alt="Camera" />
                  </ImageWrapper>
                ) : (
                  <ImageWrapper>
                    <Image src={CameraTwo} alt="camera image" />
                  </ImageWrapper>
                )}
              </>
            )}
            <LogoTitle>CAMERA #2</LogoTitle>
          </DashboardCard>
          {/* <DashboardCard image={CameraTwo}>
            <LogoTitle>CAMERA #2</LogoTitle>
          </DashboardCard> */}
        </DashboardContainerLeft>
        <DashboardContainerRight>
          <DashboardContainerRightTitle>CAMERA #1</DashboardContainerRightTitle>
          <DashboardContainerRightTitle>CAMERA #2</DashboardContainerRightTitle>
        </DashboardContainerRight>
      </DashboardCardContainer>
      {/* table view */}
      <DashboardTableContainer>
        <DashboardTableView>
          <DashboardTableContent>
            <Label weight="bold" size="header1" color="lightGreen" transform="uppercase">
              <IntlMessages id="dashboard.visitors" />
            </Label>
            <DashboardTable data={tableData} />
          </DashboardTableContent>
        </DashboardTableView>
        <DashboardCountView>
          <Label weight="bold" size="header1" color="lightGreen" transform="uppercase">
            <IntlMessages id="dashboard.counts" />{' '}
            <span style={{ color: '#fff', paddingLeft: '5px' }}>{userRole?.companyName}</span>
          </Label>
          <DashboardCountContainer>
            <DashboardCountContainerRight>
              <DashboardCountCard onClick={() => handleNaviagte('/roles')}>
                <DashboardCountCardLeft>
                  <CountTitle
                    onMouseEnter={() => handleMouseEnter(setIsHoveredUser)}
                    onMouseLeave={() => handleMouseLeave(setIsHoveredUser)}
                    style={{ cursor: 'pointer' }}
                  >
                    <LabelCount>{userCountQuery?.data ?? 0}</LabelCount>
                  </CountTitle>
                </DashboardCountCardLeft>
                <DashboardCountCardRight>
                  <IntlMessages id="nav.roles" />
                </DashboardCountCardRight>
                {showTooltipUser && (
                  <CenterContainer position={'top'} marginLeft={'-150px'}>
                    <TooltipBox
                      background={'0B2629'}
                      borderColor={'E6B471'}
                      borderRadius={'10px'}
                      padding={'10px'}
                      textAlign={'left'}
                      width={'260px'}
                    >
                      <Label>
                        <IntlMessages id="user.hover.info.text" />
                      </Label>
                    </TooltipBox>
                  </CenterContainer>
                )}
              </DashboardCountCard>
              <DashboardCountCard onClick={() => handleNaviagte('/cvd')}>
                <DashboardCountCardLeft>
                  <CountTitle
                    onMouseEnter={() => handleMouseEnter(setIsHoveredPremise)}
                    onMouseLeave={() => handleMouseLeave(setIsHoveredPremise)}
                    style={{ cursor: 'pointer' }}
                  >
                    <LabelCount>{CVDCounts?.data ?? 0}</LabelCount>
                  </CountTitle>
                </DashboardCountCardLeft>
                <DashboardCountCardRight>CVD's</DashboardCountCardRight>
                {showTooltipPremise && (
                  <CenterContainer position={'top'} marginLeft={'-150px'}>
                    <TooltipBox
                      background={'0B2629'}
                      borderColor={'E6B471'}
                      borderRadius={'10px'}
                      padding={'10px'}
                      textAlign={'left'}
                      width={'260px'}
                    >
                      <Label>
                        <IntlMessages id="cvd.hover.info.text" />
                      </Label>
                    </TooltipBox>
                  </CenterContainer>
                )}
              </DashboardCountCard>
              <DashboardCountCard onClick={() => handleNaviagte('/geofences')}>
                <DashboardCountCardLeft>
                  <CountTitle
                    onMouseEnter={() => handleMouseEnter(setIsHoveredGeofence)}
                    onMouseLeave={() => handleMouseLeave(setIsHoveredGeofence)}
                    style={{ cursor: 'pointer' }}
                  >
                    <LabelCount>{geofenceCountQuery?.data ?? 0}</LabelCount>
                  </CountTitle>
                </DashboardCountCardLeft>
                <DashboardCountCardRight>
                  <IntlMessages id="nav.geofences" />
                </DashboardCountCardRight>{' '}
                {showTooltipGeofence && (
                  <CenterContainer position={'top'} marginLeft={'-150px'}>
                    <TooltipBox
                      background={'0B2629'}
                      borderColor={'E6B471'}
                      borderRadius={'10px'}
                      padding={'10px'}
                      textAlign={'left'}
                      width={'260px'}
                    >
                      <Label>
                        <IntlMessages id="geofence.hover.info.text" />
                      </Label>
                    </TooltipBox>
                  </CenterContainer>
                )}
              </DashboardCountCard>
            </DashboardCountContainerRight>
            <DashboardCountContainerLeft>
              <DashboardCountCard onClick={() => handleNaviagte('/logrecords')}>
                <DashboardCountCardLeft>
                  <CountTitle
                    onMouseEnter={() => handleMouseEnter(setIsHoveredLogBook)}
                    onMouseLeave={() => handleMouseLeave(setIsHoveredLogBook)}
                    style={{ cursor: 'pointer' }}
                  >
                    <LabelCount>{logBookCountQuery?.data ?? 0}</LabelCount>
                  </CountTitle>
                </DashboardCountCardLeft>
                <DashboardCountCardRight>
                  <IntlMessages id="nav.records.logRecords" />
                </DashboardCountCardRight>{' '}
                {showTooltipLogBook && (
                  <CenterContainer position={'top'} marginLeft={'-155px'}>
                    <TooltipBox
                      background={'0B2629'}
                      borderColor={'E6B471'}
                      borderRadius={'10px'}
                      padding={'10px'}
                      textAlign={'left'}
                      width={'260px'}
                    >
                      <Label>
                        <IntlMessages id="logbook.hover.info.text" />
                      </Label>
                    </TooltipBox>
                  </CenterContainer>
                )}
              </DashboardCountCard>
              {/* <DashboardCountCard onClick={() => handleNaviagte('/notifications')}>
                <DashboardCountCardLeft>
                  <CountTitle
                    onMouseEnter={() => handleMouseEnter(setIsHoveredNotification)}
                    onMouseLeave={() => handleMouseLeave(setIsHoveredNotification)}
                    style={{ cursor: 'pointer' }}
                  >
                    <LabelCount>0</LabelCount>
                  </CountTitle>
                </DashboardCountCardLeft>
                <DashboardCountCardRight>
                  <IntlMessages id="nav.records.notifications" />
                </DashboardCountCardRight>{' '}
                {showTooltipNotification && (
                  <CenterContainer position={'top'} marginLeft={'-155px'}>
                    <TooltipBox
                      background={'0B2629'}
                      borderColor={'E6B471'}
                      borderRadius={'10px'}
                      padding={'10px'}
                      textAlign={'left'}
                      width={'260px'}
                    >
                      <Label >
                        <IntlMessages id="notification.hover.info.text" />
                      </Label>
                    </TooltipBox>
                  </CenterContainer>
                )}
              </DashboardCountCard> */}
              <DashboardCountCard onClick={() => handleNaviagte('/sos')}>
                <DashboardCountCardLeft>
                  <CountTitle
                    onMouseEnter={() => handleMouseEnter(setIsHoveredSOS)}
                    onMouseLeave={() => handleMouseLeave(setIsHoveredSOS)}
                    style={{ cursor: 'pointer' }}
                  >
                    <LabelCount>0</LabelCount>
                  </CountTitle>
                </DashboardCountCardLeft>
                <DashboardCountCardRight>
                  <IntlMessages id="nav.records.sos" />
                </DashboardCountCardRight>{' '}
                {showTooltipSOS && (
                  <CenterContainer position={'top'} marginLeft={'-155px'}>
                    <TooltipBox
                      background={'0B2629'}
                      borderColor={'E6B471'}
                      borderRadius={'10px'}
                      padding={'10px'}
                      textAlign={'left'}
                      width={'260px'}
                    >
                      <Label>
                        <IntlMessages id="sos.hover.info.text" />
                      </Label>
                    </TooltipBox>
                  </CenterContainer>
                )}
              </DashboardCountCard>
            </DashboardCountContainerLeft>
          </DashboardCountContainer>
        </DashboardCountView>
      </DashboardTableContainer>
    </DashboardContainer>
  );
};

export default Dashboard;
